import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { FormArray, FormGroup } from "@angular/forms";
import { UploadFilesService } from "src/app/Services/upload-files.service";
import Swal from "sweetalert2";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-image-uploader",
    templateUrl: "./image-uploader.component.html",
    styleUrls: ["./image-uploader.component.scss"],
})
export class ImageUploaderComponent implements OnInit {
    @Input() myForm: FormGroup = new FormGroup({});
    @Input() myFormArr: FormArray = new FormArray([]);
    @Input() fileType: string = "";
    @Input() myFormGroupName!: number | string;
    @Input() formControlChildName: string = "";
    @Input() noPreview: boolean = false;
    @Input() fileUrl: any;
    @Input() height: string = "";
    @Input() width: string = "";
    @Input() index: any;
    @Output() uploadedImageUrl = new EventEmitter();
    @ViewChild("mainUploader") mainUploader: any;
    trustedUrl: any;
    loading: boolean = false;
    reader: FileReader = new FileReader();
    fallbackImage: string;
    selectFile: any;
    lang: string = "en";

    @Input() imageUrl: any;
    @Input() isPdf: boolean = false;
    @Input() pdfUrl: any;
    
    constructor(
        private sanitizer: DomSanitizer,
        private uploadFile: UploadFilesService,
        private embryoService: EmbryoService,
        private translate: TranslateService
    ) {
        this.embryoService.emitLang.subscribe((lang: string) => {
            if (lang) {
                this.translate.setDefaultLang(lang);
                this.lang = lang;
            }
        });
        this.fallbackImage = "assets/images/image-uploader.png";
    }

    ngOnInit() {
        this.loadData();
    }

    ngOnChanges() {
        this.loadData();
    }

    loadData() {
        this.imageUrl = this.fileUrl;
        this.checkUrlType();
    }
    
    removeFile(formControler: any) {
        if(this.myForm && formControler && this.myForm.controls[formControler]){
            this.myForm.controls[formControler].setValue(null);
        }
        if (this.myFormArr && this.myFormGroupName && this.formControlChildName) {
            (this.myFormArr.controls[this.myFormGroupName as number] as FormGroup)
                .controls[this.formControlChildName].setValue(null);
        }
        this.isPdf = false;
        this.imageUrl = null;
        this.pdfUrl = null;
        this.mainUploader.nativeElement.value = "";
    }

    checkUrlType() {
        if (this.imageUrl) {
            const pdf = this.imageUrl.substring(
                this.imageUrl.length - 3,
                this.imageUrl.length
            );
            this.isPdf = pdf === "pdf" ? true : false;
        }
    }

    trustURL(url: any) {
        this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        return this.trustedUrl;
    }

    onImageSelected(event: any) {
        if (event.target.value) {
            this.loading = true;
            this.selectFile = <File>event.target.files[0];
            const typeImage = this.selectFile.type.split("/")[0];
            const typePdf = this.selectFile.type.split("/")[1];
            const fileType = this.selectFile.name.split(".")[1];
            if (
                this.fileType &&
                this.fileType?.length > 0 &&
                typeImage != "image"
            ) {
                this.loading = false;
                Swal.fire({
                    html: `<p style='color:white'>${
                        this.lang == "en"
                            ? "You Have To Choose Image Only"
                            : "من فضلك قم بإختيار ملف صوره"
                    }</p>`,
                    width: 250,
                    position: "bottom-end",
                    background: "#bd362f",
                    timerProgressBar: true,
                    showConfirmButton: false,
                    timer: 3000,
                    backdrop: false,
                    allowOutsideClick: true,
                });
            } else {
                if (typeImage === "image" || typePdf === "pdf" || fileType === "doc" || fileType === "docx") {
                    this.reader.readAsDataURL(event.target.files[0]);
                    this.reader.onload = (_event) => {
                        if (typeImage === "image") {
                            this.imageUrl = this.reader.result;
                        }
                    };
                    this.uploadFile.uploadFile(this.selectFile).subscribe(
                        (response: any) => {
                            if (response.code === 200) {
                                this.loading = false;
                                this.imageUrl = response.data.filePath;
                                if (typePdf === "pdf" || fileType === "doc" || fileType === "docx") {
                                    this.pdfUrl = this.trustURL(this.imageUrl);
                                }
                                this.checkUrlType();
                                if (this.myForm && this.formControlChildName && !this.myFormArr) {
                                    this.myForm.controls[
                                        this.formControlChildName
                                    ].setValue(this.imageUrl);
                                }
                                if (this.myFormArr && this.myFormGroupName && this.formControlChildName) {
                                    (this.myFormArr.controls[this.myFormGroupName as number] as FormGroup)
                                        .controls[this.formControlChildName].setValue(this.imageUrl);
                                }
                                this.uploadedImageUrl.emit(this.imageUrl);
                            }
                        },
                        (error: any) => {
                            console.error(error);
                            this.loading = false;
                        },
                        () => {
                            this.loading = false;
                        }
                    );
                } else {
                    this.loading = false;
                    this.selectFile = null;
                }
            }
        }
    }
}
